<section class="container-fluid">
    <div class="row mt-3">
        <div class="col-12">
            <ngx-ui-loader [loaderId]="loaderName"
                           bgsColor="rgb(100, 181, 246)"
                           bgsPosition="center-center"
                           bgsType="ball-spin"
                           overlayColor="rgba(0, 0, 0, 0.1)"></ngx-ui-loader>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-12 d-flex align-items-center">
            <mat-form-field style="max-width: 200px">
                <input matInput [(ngModel)]="searchFilter" (ngModelChange)="applyFilter()" placeholder="Search">
                <span matPrefix><i class="fa fa-search"></i></span>
            </mat-form-field>
            <button ni-button [view]="'error'" size="small" (click)="clearSearch()" class="ml-2">
                Clear All Filters
            </button>
        </div>
    </div>

    <div *ngIf="dataSource" class="row">
        <div class="col-md-8">
            <table [dataSource]="dataSource" class="w-100" mat-table matSort>
                <ng-container matColumnDef="icao">
                    <th *matHeaderCellDef mat-header-cell mat-sort-header>
                        <span>ICAO Code</span>
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        {{ row.icao }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>
                        <button
                            (click)="openAddDialog()"
                            [view]="'accent'"
                            beforeIcon="fa fa-plus"
                            ni-button
                        >
                            Add New
                        </button>
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        <button (click)="removeIcao(row)"
                                [view]="'error'"
                                beforeIcon="fa fa-trash"
                                ni-button
                                size="small">
                            Delete
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
                <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
            </table>

            <div *ngIf="dataSource?.data?.length === 0" class="text-center py-4">
                <p>No ICAOs are currently enabled for 1200.aero</p>
            </div>
            <div *ngIf="dataSource?.data?.length > 0 && dataSource?.filteredData?.length === 0" class="text-center py-4">
                <p>No ICAOs match your search</p>
            </div>
        </div>
    </div>
</section>
